import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
import tag from './tag'
/**
* @see \App\Http\Controllers\Rider\MyPhotosController::index
* @see app/Http/Controllers/Rider/MyPhotosController.php:46
* @route '/profil/fotky'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/profil/fotky',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Rider\MyPhotosController::index
* @see app/Http/Controllers/Rider/MyPhotosController.php:46
* @route '/profil/fotky'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Rider\MyPhotosController::index
* @see app/Http/Controllers/Rider/MyPhotosController.php:46
* @route '/profil/fotky'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Rider\MyPhotosController::index
* @see app/Http/Controllers/Rider/MyPhotosController.php:46
* @route '/profil/fotky'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Rider\MyPhotosController::index
* @see app/Http/Controllers/Rider/MyPhotosController.php:46
* @route '/profil/fotky'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Rider\MyPhotosController::index
* @see app/Http/Controllers/Rider/MyPhotosController.php:46
* @route '/profil/fotky'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Rider\MyPhotosController::index
* @see app/Http/Controllers/Rider/MyPhotosController.php:46
* @route '/profil/fotky'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Rider\SavedPhotoController::save
* @see app/Http/Controllers/Rider/SavedPhotoController.php:26
* @route '/profil/fotky/{photo}'
*/
export const save = (args: { photo: number | { id: number } } | [photo: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: save.url(args, options),
    method: 'post',
})

save.definition = {
    methods: ["post"],
    url: '/profil/fotky/{photo}',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Rider\SavedPhotoController::save
* @see app/Http/Controllers/Rider/SavedPhotoController.php:26
* @route '/profil/fotky/{photo}'
*/
save.url = (args: { photo: number | { id: number } } | [photo: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { photo: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { photo: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            photo: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        photo: typeof args.photo === 'object'
        ? args.photo.id
        : args.photo,
    }

    return save.definition.url
            .replace('{photo}', parsedArgs.photo.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Rider\SavedPhotoController::save
* @see app/Http/Controllers/Rider/SavedPhotoController.php:26
* @route '/profil/fotky/{photo}'
*/
save.post = (args: { photo: number | { id: number } } | [photo: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: save.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Rider\SavedPhotoController::save
* @see app/Http/Controllers/Rider/SavedPhotoController.php:26
* @route '/profil/fotky/{photo}'
*/
const saveForm = (args: { photo: number | { id: number } } | [photo: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: save.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Rider\SavedPhotoController::save
* @see app/Http/Controllers/Rider/SavedPhotoController.php:26
* @route '/profil/fotky/{photo}'
*/
saveForm.post = (args: { photo: number | { id: number } } | [photo: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: save.url(args, options),
    method: 'post',
})

save.form = saveForm

/**
* @see \App\Http\Controllers\Rider\SavedPhotoController::unsave
* @see app/Http/Controllers/Rider/SavedPhotoController.php:41
* @route '/profil/fotky/{photo}'
*/
export const unsave = (args: { photo: number | { id: number } } | [photo: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: unsave.url(args, options),
    method: 'delete',
})

unsave.definition = {
    methods: ["delete"],
    url: '/profil/fotky/{photo}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Rider\SavedPhotoController::unsave
* @see app/Http/Controllers/Rider/SavedPhotoController.php:41
* @route '/profil/fotky/{photo}'
*/
unsave.url = (args: { photo: number | { id: number } } | [photo: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { photo: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { photo: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            photo: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        photo: typeof args.photo === 'object'
        ? args.photo.id
        : args.photo,
    }

    return unsave.definition.url
            .replace('{photo}', parsedArgs.photo.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Rider\SavedPhotoController::unsave
* @see app/Http/Controllers/Rider/SavedPhotoController.php:41
* @route '/profil/fotky/{photo}'
*/
unsave.delete = (args: { photo: number | { id: number } } | [photo: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: unsave.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Rider\SavedPhotoController::unsave
* @see app/Http/Controllers/Rider/SavedPhotoController.php:41
* @route '/profil/fotky/{photo}'
*/
const unsaveForm = (args: { photo: number | { id: number } } | [photo: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: unsave.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Rider\SavedPhotoController::unsave
* @see app/Http/Controllers/Rider/SavedPhotoController.php:41
* @route '/profil/fotky/{photo}'
*/
unsaveForm.delete = (args: { photo: number | { id: number } } | [photo: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: unsave.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

unsave.form = unsaveForm

const photos = {
    index: Object.assign(index, index),
    save: Object.assign(save, save),
    unsave: Object.assign(unsave, unsave),
    tag: Object.assign(tag, tag),
}

export default photos